module.exports = __webpack_public_path__ + "static/img/logo02.a9299cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUs/logo02.png
// module id = a+P2
// module chunks = 1